import { v3dMesh } from '@/Interfaces/common';
import { IV3D } from '@/Interfaces/v3d';
declare let v3d: IV3D;
export default function changeColor(item: v3dMesh, node: string, hexColor: string) {
    if (!item) return;
    const RgbExternalIndex = item.material.nodeRGBMap[node];
    if (typeof RgbExternalIndex === 'undefined') return;
    const color = new v3d.Color(hexColor);
    color.convertSRGBToLinear();
    item.material.nodeRGB[RgbExternalIndex].x = color.r;
    item.material.nodeRGB[RgbExternalIndex].y = color.g;
    item.material.nodeRGB[RgbExternalIndex].z = color.b;
    item.material.needsUpdate = true;
}
